(ns common.schema.entities.signatory
  (:require
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def sign-status-options
  (->> [{:value :signatory.sign-status/not-sent
         :label "Not sent"}
        {:value :signatory.sign-status/undecided
         :label "Undecided"}
        {:value :signatory.sign-status/signed
         :label "Signed"}
        {:value :signatory.sign-status/declined
         :label "Declined"}
        {:value :signatory.sign-status/unknown
         :label "Unknown"}]
       (mapv (fn [{:keys [value] :as opt}]
               (assoc opt :key value)))))

(def sign-status-label-lookup
  (->> sign-status-options
       (mapv (fn [{:keys [value label]}]
               [value label]))
       (into {})))

(defn get-sign-status-label
  [status]
  (get sign-status-label-lookup status))

(def schema
  (concat
   (su/text-simple-field :signatory/name
                         "Name"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use})
   (su/text-simple-field :signatory/email
                         "Email"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use})

   ;; TODO: in schema.db, this field is boolean data-type, but here text?
   (su/text-simple-field :signatory/signed?
                         "Signed"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use})
   (su/text-simple-field :signatory/reminded?
                         "Reminded"
                         {:authorization            su/access-user-user
                          :default-field-visibility :in-use})
   (su/datetime-field :signatory/last-reminded-on
                      "Reminded on"
                      (system-controlled {:authorization            su/access-system-user
                                          :default-field-visibility :in-use}))

   (su/keyword-field :signatory/sign-status
                     "Sign status"
                     sign-status-options
                     (system-controlled {:authorization            su/access-system-user
                                         :default-field-visibility :in-use}))))
